import { MILESTONE_EMOJIS } from '../../constants';
import { useMoneyStatistics } from '../../hooks/useMoneyStatistics';
import { formatPrice } from '../../utils/priceFormatter';

const FlagClassNames = [
  '-top-4 -bottom-1',
  '-bottom-4 -top-1',
  '-top-9 md:-top-4 -bottom-1',
  '-bottom-9 md:-bottom-4 -top-1',
];

export const GoalProgressBar = () => {
  const { isLoading, current, target, milestonesToShow } = useMoneyStatistics();

  return (
    <div
      className={`${
        milestonesToShow.length > 2 ? 'mt-16 md:mt-12' : 'mt-12'
      } flex flex-col md:items-center lg:w-10/12 xl:w-8/12 self-stretch lg:self-center`}
    >
      <div className="relative w-full">
        <progress
          className="progress progress-primary h-4 bg-neutral-800"
          value={(current * 100) / target}
          max="100"
        />
        {milestonesToShow.map((milestone, index) => (
          <div
            key={milestone}
            className={`absolute left-0 flex justify-end border-r-2 border-secondary ${FlagClassNames[index]}`}
            style={{ right: `${100 - (milestone * 100) / target}%` }}
          >
            <div
              className={`absolute -mr-[2px] badge badge-sm badge-secondary ${
                index % 2
                  ? 'bottom-0 translate-y-1/2'
                  : 'top-0 -translate-y-1/2'
              }`}
            >
              <span className="truncate">
                {formatPrice(milestone).split(',')[0]}k goal is reached{' '}
              </span>
              <img src={MILESTONE_EMOJIS[index]} className="ml-1 h-3" />
            </div>
          </div>
        ))}
      </div>

      <p
        className={`${
          milestonesToShow.length > 3 ? 'mt-12 md:mt-8' : 'mt-8'
        } text-primary text-2xl`}
      >
        <span className="relative">
          <span
            className={`transition-opacity ${isLoading ? 'opacity-30' : ''}`}
          >
            {formatPrice(current)}
          </span>

          {isLoading && (
            <progress className="absolute top-1/2 left-1/2 -translate-x-1/2 progress progress-primary w-3/4" />
          )}
        </span>{' '}
        {` / ${formatPrice(target)}`}
      </p>

      <p className="mt-1 text-sm opacity-40">
        * includes individual and partners' donations
      </p>
    </div>
  );
};
